export default __webpack_public_path__ + "static/media/monitoring.7b819e84.svg";